import { axiosPath, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    AllLevels: [],
    AllLevelBenefitsByLevelId: [],
  },
  mutations: {
    setAllLevels(state, data) {
      state.AllLevels = data;
    },
    setAllLevelBenefitsByLevelId(state, data) {
      state.AllLevelBenefitsByLevelId = data;
    },

    deleteLevelBenefit(state, ID) {
      let index = state.AllLevelBenefitsByLevelId.findIndex(
        (val) => val.level_benefit_id == ID
      );
      state.AllLevelBenefitsByLevelId.splice(index, 1);
    },
  },
  actions: {
    async getAllLevels({ dispatch, commit }) {
      let url = "/api/v1/AllLevels";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setAllLevels", res.data);
        return res;
      }
    },
    async getAllLevelBenefitsByLevelId({ dispatch, commit }, level_id) {
      let url = `${backendVersion.version}/AllLevelBenefitsByLevelId/${level_id}`;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setAllLevelBenefitsByLevelId", res.data);
        return res;
      }
    },
    async createLevelBenefit({ dispatch, commit }, form) {
      let url = `${backendVersion.version}/CreateLevelBenefit`;
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          commit("setAllLevelBenefitsByLevelId", res.data);
          return true;
        } else {
          return false;
        }
      }
    },
    async deleteLevelBenefit({ dispatch, commit }, level_benefit_id) {
      let url = `${backendVersion.version}/DeleteLevelBenefit/${level_benefit_id}`;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        alert("Can't delete this LevelBenefit.");
        return false;
      } else {
        if (res.msg == true) {
          commit("deleteLevelBenefit", level_benefit_id);
          return true;
        } else {
          alert("Can't delete this LevelBenefit");
          return false;
        }
      }
    },
    async updateLevelBenefit({ commit, dispatch, rootState }, form) {
      let url = `${backendVersion.version}/EditLevelBenefit/${form.level_benefit_id}`;

      if (!form.level_benefit_image) {
        delete form["level_benefit_image"];
      }
      delete form["level_benefit_id"];
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        console.log("change status success");
        commit("setAllLevelBenefitsByLevelId", res.data);
        return true;
      }
    },
  },
  getters: {},
};
